module.exports = "/assets/data/3e9ba10ed3f65d387e1f60dd5fb01b5b-G64.data.json";